import QueryString from 'qs';
import { v4 } from 'uuid';

// Gets the transactionId from the URL query strings 'cid'.
export function getTransactionId() {
  const dataStorageId = '';

  const search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  if (search.cid) {
    return search.cid as string;
  }
  return dataStorageId;
}

// Gets and decode the ScriveLink from the URL query string parameter 'url'.
export function getScriveLink() {
  const scriveLink = '';

  const search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  if (search.url) {
    return atob(search.url.toString()) as string;
  }
  return scriveLink;
}

export const SELECT_CHOOSE_VALUE = {
  value: v4(),
  label: 'Random',
};
